/*
 * Copyright (c) 2018-present, Revolut LTD.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createGlobalStyle } from 'styled-components'
import { SANS_SERIF, SIZES } from './constants'

export const GlobalStyle = createGlobalStyle`
  body {
    overflow-y: scroll;
  }

  html {
    font-size: ${SIZES.REGULAR};
    font-family: ${SANS_SERIF};
  }

  :root {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased
  }

  * {
    box-sizing: border-box;
  }
`
